import { extendTheme } from '@chakra-ui/react';

const theme = extendTheme({
  fonts: {
    heading: `'Noto Sans JP', 'Microsoft YaHei', sans-serif`,
    body: `'Noto Sans JP', 'Microsoft YaHei', sans-serif`,
  },
  styles: {
    global: {
      body: {
        bg: 'orange.50',
        fontFamily: `'Noto Sans JP', 'Microsoft YaHei', sans-serif`,
      },
    },
  },
  components: {
    Button: {
      baseStyle: {
        fontFamily: `'Noto Sans JP', 'Microsoft YaHei', sans-serif`,
      },
    },
  },
});

export default theme;
